import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import CardDmc from '../../components/CardDmc';

import styles from './ListCardDmc.module.scss';

const ListCardDmc = ({ items }) => {
    const { t } = useTranslation();

    return (
        <div className={styles['ListCardDmc']}>
            <h3 className={styles['ListCardDmc__Title']}>
                {t('listCardPage.result', { shownHits: items.length })}
            </h3>

            {items.length > 0 && (
                <div className={styles['ListCardDmc__Items']}>
                    {items.map((item) => (
                        <CardDmc key={item.id} {...item} isDmc={true} />
                    ))}
                </div>
            )}
        </div>
    );
};

ListCardDmc.propTypes = {
    items: PropTypes.array,
    activeSortPath: PropTypes.string,
    onSort: PropTypes.func,
};

ListCardDmc.defaultProps = {
    items: [],
    activeSortPath: '',
};

export default ListCardDmc;
